// ── Colors, Theme, Language, Helpers ──────────────────
export const C = {
  bg:"#F0F4F8",card:"#fff",border:"#E2E8F0",
  primary:"#2563EB",success:"#10B981",danger:"#EF4444",
  warning:"#F59E0B",info:"#3B82F6",text:"#1E293B",
  sub:"#64748B",light:"#94A3B8",side:"#1C2B3A",
  sideT:"#CBD5E1",purple:"#7C3AED",
};
export const CC = ["#2563EB","#7C3AED","#059669","#DC2626","#D97706","#0891B2"];
export const SC = {Delivered:"#10B981",Processing:"#F59E0B",Pending:"#EF4444",Received:"#10B981",Dispatched:"#F59E0B"};
export const NC = {"Credit Note":"#10B981","Debit Note":"#EF4444","Sale Return":"#F59E0B","Purchase Return":"#7C3AED"};
export const NI = {"Credit Note":"📗","Debit Note":"📕","Sale Return":"↩️","Purchase Return":"↪️"};

export const LANG={
  en:{
    dashboard:"Dashboard",orders:"Orders",payments:"Payments",invoice:"Invoice",
    customers:"Customers",suppliers:"Suppliers",products:"Products",
    purchases:"Purchases",inventory:"Inventory",staff:"Staff",settings:"Settings",
    companies:"Companies",salesAnalysis:"Sales Analysis",profitLoss:"Profit & Loss",
    gstReport:"GST Report",downloads:"Downloads",notes:"CR/DR Notes",
    myDeliveries:"My Deliveries",beats:"Beat Management",expenses:"Expenses",
    cheques:"Cheques",loyalty:"Customer Loyalty",
    save:"Save",cancel:"Cancel",delete:"Delete",edit:"Edit",search:"Search...",
    total:"Total",paid:"Paid",due:"Due",balance:"Balance",
    welcome:"Welcome",logout:"Logout",
  },
  hi:{
    dashboard:"डैशबोर्ड",orders:"ऑर्डर",payments:"भुगतान",invoice:"चालान",
    customers:"ग्राहक",suppliers:"आपूर्तिकर्ता",products:"उत्पाद",
    purchases:"खरीद",inventory:"स्टॉक",staff:"स्टाफ",settings:"सेटिंग",
    companies:"कंपनियां",salesAnalysis:"बिक्री विश्लेषण",profitLoss:"लाभ/हानि",
    gstReport:"GST रिपोर्ट",downloads:"डाउनलोड",notes:"CR/DR नोट्स",
    myDeliveries:"मेरी डिलीवरी",beats:"बीट प्रबंधन",expenses:"खर्च",
    cheques:"चेक",loyalty:"ग्राहक लॉयल्टी",
    save:"सेव करें",cancel:"रद्द करें",delete:"हटाएं",edit:"संपादित करें",search:"खोजें...",
    total:"कुल",paid:"चुकाया",due:"बाकी",balance:"बैलेंस",
    welcome:"स्वागत है",logout:"लॉगआउट",
  }
};
export const T=(lg,key)=>LANG[lg]?.[key]||LANG.en[key]||key;

export const fmt = n => Math.round(n||0).toLocaleString("en-IN");
// India runs on IST (UTC+5:30). Using toISOString() here would convert to UTC first,
// which silently shows YESTERDAY's date for anything happening between 12:00 AM and
// 5:29 AM IST — this bit orders, payments, and expenses saved during early-morning
// dispatch. getFullYear()/getMonth()/getDate() are local-timezone-aware (the device's
// own clock), so they give the correct IST calendar date without any conversion.
const pad2 = (n) => String(n).padStart(2, "0");
export const toLocalDateStr = (d) => `${d.getFullYear()}-${pad2(d.getMonth()+1)}-${pad2(d.getDate())}`;

export const today = () => toLocalDateStr(new Date());
export const todayStr = () => toLocalDateStr(new Date());
export const monthStart = () => {const d=new Date();return toLocalDateStr(new Date(d.getFullYear(),d.getMonth(),1));};
export const monthEnd = () => {const d=new Date();return toLocalDateStr(new Date(d.getFullYear(),d.getMonth()+1,0));};
export const fyStart = () => {const d=new Date();const y=d.getMonth()<3?d.getFullYear()-1:d.getFullYear();return y+"-04-01";};
export const fyEnd = () => {const d=new Date();const y=d.getMonth()<3?d.getFullYear():d.getFullYear()+1;return y+"-03-31";};
export const last7 = () => {const d=new Date();d.setDate(d.getDate()-7);return toLocalDateStr(d);};
export const last30 = () => {const d=new Date();d.setDate(d.getDate()-30);return toLocalDateStr(d);};
export const filterByDate = (records,from,to) => {
  if(!from&&!to) return records;
  return records.filter(r=>{const d=r.date||r.created_at||"";return(!from||d>=from)&&(!to||d<=to);});
};
export const getFYList = () => {
  const cy=new Date().getFullYear();const list=[];
  for(let i=cy-3;i<=cy+1;i++){list.push({value:i,label:`FY ${i}-${String(i+1).slice(2)}`,start:`${i}-04-01`,end:`${i+1}-03-31`});}
  return list;
};
export const gCalc = (sub,rate,type) => {
  const g=sub*rate/100;
  return type==="CGST_SGST"?{c:g/2,s:g/2,i:0,t:g}:{c:0,s:0,i:g,t:g};
};
export const dlCSV = (fn,h,rows) => {
  const e=v=>{const s=String(v??"");return s.includes(",")||s.includes('"')?`"${s.replace(/"/g,'""')}"`  :s;};
  const c=[h.map(e).join(","),...rows.map(r=>r.map(e).join(","))].join("\n");
  const a=document.createElement("a");a.href=URL.createObjectURL(new Blob(["\uFEFF"+c],{type:"text/csv;charset=utf-8"}));a.download=fn;a.click();
};
export function numToWords(n){
  if(!n)return"Zero";
  const ones=["","One","Two","Three","Four","Five","Six","Seven","Eight","Nine","Ten","Eleven","Twelve","Thirteen","Fourteen","Fifteen","Sixteen","Seventeen","Eighteen","Nineteen"];
  const tens=["","","Twenty","Thirty","Forty","Fifty","Sixty","Seventy","Eighty","Ninety"];
  const h=(num)=>{if(num<20)return ones[num];if(num<100)return tens[Math.floor(num/10)]+(num%10?" "+ones[num%10]:"");return ones[Math.floor(num/100)]+" Hundred"+(num%100?" "+h(num%100):"");};
  const cr=Math.floor(n/10000000);const lac=Math.floor((n%10000000)/100000);const thou=Math.floor((n%100000)/1000);const rest=n%1000;
  return((cr?h(cr)+" Crore ":"")+(lac?h(lac)+" Lakh ":"")+(thou?h(thou)+" Thousand ":"")+(rest?h(rest):"")).trim();
}

// ── Plan Limits & Feature Control ─────────────────────
export const PLAN_LIMITS = {
  trial: {
    maxStaff: 2, maxCompanies: 1, maxProducts: 50,
    features: ["orders","invoice","payments","customers","suppliers","stock","dash"]
  },
  starter: {
    maxStaff: 2, maxCompanies: 1, maxProducts: 100,
    features: ["orders","invoice","payments","customers","suppliers","stock","dash","settings","comps","prods","beats","deliveries"]
  },
  basic: {
    maxStaff: 5, maxCompanies: 5, maxProducts: 300,
    features: ["orders","invoice","payments","customers","suppliers","stock","dash",
               "settings","comps","prods","beats","deliveries",
               "gst","expenses","cheques","notes","purs","supps","dl","pays","inv","staff","sales"]
  },
  pro: {
    maxStaff: 10, maxCompanies: 10, maxProducts: 999999,
    features: ["orders","invoice","payments","customers","suppliers","stock","dash",
               "settings","comps","prods","beats","deliveries",
               "gst","expenses","cheques","notes","purs","supps","dl","pays","inv","staff","sales",
               "photoscan","pl","analytics","tally","multiAdmin","custs"]
  },
  enterprise: {
    maxStaff: 999999, maxCompanies: 999999, maxProducts: 999999,
    features: ["all"]
  }
};

export const PLAN_NAMES = {
  trial: {name:"Trial", color:"#64748B", icon:"⏳", price:0},
  starter: {name:"Starter", color:"#64748B", icon:"⭐", price:299},
  basic: {name:"Basic", color:"#2563EB", icon:"🚀", price:499},
  pro: {name:"Pro", color:"#7C3AED", icon:"💎", price:999},
  enterprise: {name:"Enterprise", color:"#059669", icon:"🏢", price:1999},
};

export const canAccess = (plan, feature) => {
  const limits = PLAN_LIMITS[plan] || PLAN_LIMITS.trial;
  return limits.features.includes("all") || limits.features.includes(feature);
};

export const getPlanLimit = (plan, key) => {
  return (PLAN_LIMITS[plan] || PLAN_LIMITS.trial)[key] || 0;
};

export const UPGRADE_MSG = {
  gst: "GST Reports Basic plan mein available hai",
  expenses: "Expenses Basic plan mein available hai",
  cheques: "Cheque Management Basic plan mein available hai",
  notes: "CR/DR Notes Basic plan mein available hai",
  purs: "Purchase Management Basic plan mein available hai",
  photoscan: "AI Bill Scanner Pro plan mein available hai",
  pl: "Profit & Loss Pro plan mein available hai",
  sales: "Sales Analysis Basic plan mein available hai",
  tally: "Tally/Busy Export Pro plan mein available hai",
  multiAdmin: "Multi Admin Pro plan mein available hai",
};

